import type { Subtask, SubtaskTimeEntry, TaskStatus } from './types'

export function isSubtaskContributor(subtask: Subtask, user: string) {
  return subtask.owner === user || subtask.reviewer === user || (subtask.supportUsers ?? []).includes(user) || (subtask.timeEntries ?? []).some(entry => entry.user === user)
}

export function subtaskTimeEntries(subtask: Subtask): SubtaskTimeEntry[] {
  if (subtask.timeEntries?.length) return subtask.timeEntries
  if (!subtask.seconds && !subtask.running) return []
  return [{
    id: `legacy-${subtask.id}`,
    user: subtask.owner,
    status: subtask.status,
    seconds: subtask.seconds,
    startedAt: 'Histórico migrado',
    startedOn: subtask.completedAt ? `${subtask.completedAt}T12:00:00.000Z` : undefined,
    running: subtask.running,
  }]
}

export function userSubtaskSeconds(subtask: Subtask, user: string) {
  return subtaskTimeEntries(subtask)
    .filter(entry => entry.user === user)
    .reduce((total, entry) => total + entry.seconds, 0)
}

export function userIsTimingSubtask(subtask: Subtask, user: string) {
  return subtaskTimeEntries(subtask).some(entry => entry.user === user && entry.running)
}

export function stopSubtaskTimers(subtask: Subtask, allowedUsers?: Set<string>) {
  const timeEntries = subtaskTimeEntries(subtask).map(entry => entry.running && (!allowedUsers || !allowedUsers.has(entry.user))
    ? { ...entry, running: false }
    : entry)
  return { timeEntries, running: timeEntries.some(entry => entry.running) }
}

export function toggleUserSubtaskTimer(subtask: Subtask, user: string, session: { id: string; status: TaskStatus; startedAt: string; startedOn: string }) {
  const entries = subtaskTimeEntries(subtask)
  const wasRunning = entries.some(entry => entry.user === user && entry.running)
  const timeEntries = wasRunning
    ? entries.map(entry => entry.user === user && entry.running ? { ...entry, running: false } : entry)
    : [
        ...entries.map(entry => entry.user === user && entry.running ? { ...entry, running: false } : entry),
        { ...session, user, seconds: 0, running: true },
      ]
  return { started: !wasRunning, timeEntries, running: timeEntries.some(entry => entry.running) }
}
